import React, { useEffect, useState } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import TabComponent from "../../components/tabComponent";
import "./styles.css";
import { getCookie } from "../../utils/getCookie";
import DofaTabOrganizationContext from "./dofaTab";
import images from "../../constants/images";

const Dashboard = () => {
  const BurnDataDofa = {};
  const userSesion = getCookie("sesion");
  const userId = userSesion.id_usuario;

  const tabData = [
    {
      name: "DOFA",
      id: "0",
      content: <DofaTabOrganizationContext data={{}} userId={userId} />
    },
    ,
  ];

  return (
    <div>
      <BreadCrumbComp />

      <img
        className="organization-context-img"
        src={images.organization_context}
        alt="arrow"
        style={{ margin: "0 auto" }}
      />

      <div className="searchTitle bm-50"></div>
      <TabComponent panels={tabData} variant={"fullWidth"} />
    </div>
  );
};

export default Dashboard;
